import AdminProductionValidationCenterPanel from "../components/admin/AdminProductionValidationCenterPanel";
import AdminCommercialControlTowerPanel from "../components/admin/AdminCommercialControlTowerPanel";
import AdminMerchantOnboardingReviewPanel from "../components/admin/AdminMerchantOnboardingReviewPanel";
import AdminPartnerCandidatesPanel from "../components/admin/AdminPartnerCandidatesPanel";
import PrpAdminTerritoryCoordinateValidationPanel from "../components/prp/PrpAdminTerritoryCoordinateValidationPanel";
// src/pages/Admin.tsx
import React, { useEffect, useRef, useState } from 'react';
import { supabase } from '../services/supabaseClient';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import Header from '../components/Header';
import AdminOrdersVouchers from './AdminOrdersVouchers';
import AdminExperienceReviews from './AdminExperienceReviews';
import AdminEmailSequences from './AdminEmailSequences';
import AdminMarketingAnalytics from './AdminMarketingAnalytics';
import AdminLastCallReservations from './AdminLastCallReservations';
import AdminCombos from './AdminCombos';
import AdminCommissionSettings from './AdminCommissionSettings';
import {
  FaCheck, FaTimes, FaShieldAlt, FaSignOutAlt, FaSearch, FaTrash,
  FaStore, FaClock, FaBullhorn, FaPaperPlane, FaArrowRight,
  FaEnvelopeOpenText, FaRobot, FaMagic, FaImages, FaLock, FaKey, FaList, FaUserPlus,
  FaHandshake, FaPercentage, FaMoneyBillWave, FaEdit, FaSave, FaCheckCircle, FaVideo, FaCloudUploadAlt,
  FaBuilding, FaUserTie, FaPlus, FaBookOpen, FaQuestionCircle, FaHome,
  FaChartPie, FaDollarSign, FaFileSignature, FaHardHat, FaMapMarkedAlt, FaHotel, FaWrench, FaSpinner,
  FaExternalLinkAlt, FaStar, FaCalendarCheck
} from 'react-icons/fa';

import { PrpAdminTerritoryRegionAssignmentPanel } from "@/components/prp/PrpAdminTerritoryRegionAssignmentPanel";
// --- TYPES ---
type SelectedItem = {
  type: string; id: string; title: string; price: string;
  image: string; business: string; url: string; ctaLabel: string;
};

type Affiliate = {
  id: string; referral_code: string; status: string;
  commission_percent: number; fixed_rate: number;
  remuneration_mode: 'commission' | 'fixed';
  total_earnings: number; clicks_count: number;
  conversions_count: number; created_at: string;
  stripe_account_id?: string;
};

type HomeVideo = {
  id: string; title: string; video_url: string; created_at: string;
};

type NewsletterSubscriber = {
  id: string; email: string; postal_code: string | null; created_at: string;
};

type Tutorial = {
  id: string; title: string; content: string; video_url: string; category: string; created_at: string;
};

type HabitatProfile = {
  id: string; email: string; full_name: string; role: 'tenant' | 'landlord'; is_approved: boolean; created_at: string;
};

type Screening = {
  id: string; tenant_email: string; status: string; created_at: string; landlord_id: string;
  landlord?: { full_name: string; email: string };
};

export default function Admin() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'businesses' | 'ordersVouchers' | 'experienceReviews' | 'emailSequences' | 'marketingAnalytics' | 'lastCallReservations' | 'combos' | 'commissions' | 'announcements' | 'newsletter' | 'security' | 'affiliates' | 'payouts' | 'videos' | 'prps' | 'partnerCandidates' | 'merchantOnboarding' | 'commercialControlTower' | 'productionValidation' | 'tutorials' | 'habitat' | 'sdr'>('businesses');
  const adminTabsScrollRef = useRef<HTMLDivElement | null>(null);
  const [loading, setLoading] = useState(true);
  const [adminEmail, setAdminEmail] = useState<string | null>(null);

  // --- STATES PRP ---
  const [prpsList, setPrpsList] = useState<any[]>([]);
  const [prpPayouts, setPrpPayouts] = useState<any[]>([]);
  const [newPrpEmail, setNewPrpEmail] = useState("");
  const [newPrpRegion, setNewPrpRegion] = useState("");

  // --- STATES BUSINESSES ---
  const [businesses, setBusinesses] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");

  // --- STATES HABITAT ---
  const [habitatProfiles, setHabitatProfiles] = useState<HabitatProfile[]>([]);
  const [screenings, setScreenings] = useState<Screening[]>([]);
  const [uploadingScreeningId, setUploadingScreeningId] = useState<string | null>(null);

  const [habitatStats, setHabitatStats] = useState({
    activePros: 0,
    totalListings: 0,
    sealedLeases: 0,
    activeTickets: 0,
    totalScreenings: 0,
    rentPaymentsCount: 0
  });

  // --- STATES AFFILIATES & PAYOUTS ---
  const [affiliates, setAffiliates] = useState<Affiliate[]>([]);
  const [payouts, setPayouts] = useState<any[]>([]);
  const [editingAffiliate, setEditingAffiliate] = useState<Affiliate | null>(null);

  // --- STATES ANNOUNCEMENTS ---
  const [announcements, setAnnouncements] = useState<any[]>([]);
  const [newAnnouncement, setNewAnnouncement] = useState({ title: '', content: '', tag: 'INFO' });

  // --- STATES VIDEOS ---
  const [homeVideos, setHomeVideos] = useState<HomeVideo[]>([]);
  const [uploadingVideo, setUploadingVideo] = useState(false);
  const [newVideoTitle, setNewVideoTitle] = useState("");

  // --- STATES TUTORIELS / FAQ PROS ---
  const [tutorials, setTutorials] = useState<Tutorial[]>([]);
  const [newTutorial, setNewTutorial] = useState({ title: '', content: '', video_url: '', category: 'Général' });
  const TUTORIAL_CATEGORIES = ["Général", "Ventes & Opérations", "Mon Établissement", "Marketing & Relation", "Administration"];

  // --- STATES NEWSLETTER ---
  const [subscribers, setSubscribers] = useState<NewsletterSubscriber[]>([]);
  const [manualRecipients, setManualRecipients] = useState("");
  const [deals, setDeals] = useState<any[]>([]);
  const [products, setProducts] = useState<any[]>([]);
  const [accommodations, setAccommodations] = useState<any[]>([]);
  const [selectedItems, setSelectedItems] = useState<SelectedItem[]>([]);
  const [newsletterSubject, setNewsletterSubject] = useState("");
  const [newsletterHtml, setNewsletterHtml] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [isSending, setIsSending] = useState(false);

  // --- STATES SÉCURITÉ ---
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMessage, setPasswordMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);

  // --- STATES SDR IA AUTONOME & GESTION MANUELLE ---
  const [sdrTarget, setSdrTarget] = useState("");
  const [sdrPrompt, setSdrPrompt] = useState("Analyse leur site web et rédige un courriel de 3 lignes max proposant le Last Call de Forfeo. Ton direct et québécois.");
  const [sdrGenerateDemo, setSdrGenerateDemo] = useState(true);
  const [sdrLoading, setSdrLoading] = useState(false);
  const [sdrLeads, setSdrLeads] = useState<any[]>([]);

  // Nouveaux states pour l'ajout manuel
  const [newSdrCompany, setNewSdrCompany] = useState("");
  const [newSdrEmail, setNewSdrEmail] = useState("");

  // --- URLS & HELPERS ---
  const EXPLORE_BASE_URL = (import.meta as any)?.env?.VITE_FORFEO_EXPLORE_URL || 'https://forfeo-explore-quebec.onrender.com';
  const DEFAULT_ROUTES: Record<string, string> = { deal: '/last-call', accommodation: '/accommodation', product: '/shop' };

  const safeTrim = (v: any) => (typeof v === 'string' ? v.trim() : '');
  const isHttpUrl = (v: string) => /^https?:\/\//i.test(v);
  const addUtm = (url: string) => {
    try {
      const parsed = new URL(url);
      parsed.searchParams.set('utm_source', 'newsletter');
      parsed.searchParams.set('utm_medium', 'email');
      return parsed.toString();
    } catch { return url; }
  };
  const buildFallbackUrl = (type: string, item: any) => {
    const base = safeTrim(EXPLORE_BASE_URL);
    const route = DEFAULT_ROUTES[type] || '';
    const idOrSlug = safeTrim(item?.slug) || safeTrim(item?.handle) || safeTrim(item?.id) || '';
    return base ? `${base}${route}/${idOrSlug}` : '';
  };
  const extractBestUrl = (type: string, item: any) => {
    const candidates = [item?.url, item?.link, item?.public_url, item?.reservation_url, item?.website].map(safeTrim).filter(Boolean);
    const firstHttp = candidates.find(isHttpUrl);
    return firstHttp ? addUtm(firstHttp) : addUtm(buildFallbackUrl(type, item));
  };
  const ctaLabelForType = (type: string) => {
    if (type === 'product') return 'Acheter';
    if (type === 'deal') return 'Voir l’offre';
    return 'Réserver';
  };

  const sanitizeAiNewsletterHtml = (raw: string) => {
    let html = String(raw || '').trim();
    html = html.replace(/```html\s*/gi, '').replace(/```/g, '').trim();
    const lower = html.toLowerCase();
    const startTokens = ['<!doctype', '<html', '<body', '<table', '<div'];
    let startIndex = -1;
    for (const token of startTokens) {
      const idx = lower.indexOf(token);
      if (idx !== -1 && (startIndex === -1 || idx < startIndex)) startIndex = idx;
    }
    if (startIndex > 0) html = html.slice(startIndex).trim();
    const lower2 = html.toLowerCase();
    const endTokens = ['</html>', '</body>', '</table>', '</div>'];
    let endIndex = -1;
    for (const token of endTokens) {
      const idx = lower2.lastIndexOf(token);
      if (idx !== -1) endIndex = Math.max(endIndex, idx + token.length);
    }
    if (endIndex > 0) html = html.slice(0, endIndex).trim();
    if (!/<\/?[a-z][\s\S]*>/i.test(html)) {
      const escaped = html.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
      html = `<div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;background:#fff;border:1px solid #e5e7eb;padding:24px;border-radius:12px;"><h1 style="margin-top:0;">🌲 Forfeo Explore</h1><div style="white-space:pre-wrap;line-height:1.5;">${escaped}</div></div>`.trim();
    }
    return html;
  };

  const manualRecipientsList = manualRecipients.split(',').map(e => e.trim()).filter(e => e.includes('@'));

  useEffect(() => {
    void checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const result = await invokeAdminContent({
        action: 'check',
      });

      setAdminEmail(
        result.email || null
      );

      await fetchData();
    } catch (error) {
      console.error(
        "Accès administrateur refusé",
        error,
      );

      setLoading(false);
      window.location.replace('/login');
    }
  };

  const fetchData = async () => {
    setLoading(true);
    await Promise.all([
      fetchBusinesses(), fetchAffiliates(), fetchPayouts(),
      fetchAnnouncements(), fetchSubscribers(), fetchContent(),
      fetchVideos(), fetchPrps(), fetchPrpPayouts(), fetchTutorials(),
      fetchHabitatProfiles(), fetchHabitatStats(), fetchSdrLeads()
    ]);
    setLoading(false);
  };

  // ✅ SDR : Récupération de l'historique des Leads
  const fetchSdrLeads = async () => {
    const { data, error } = await supabase.from('sdr_leads').select('*').order('created_at', { ascending: false });
    if (!error && data) setSdrLeads(data);
    else if (error) console.error("Erreur chargement SDR:", error);
  };

  // ✅ SDR : Lancement de l'IA (Génération)
  const handleSdrScraping = async () => {
    if (!sdrTarget.trim()) {
      alert("Veuillez entrer une cible (nom d'entreprise ou URL).");
      return;
    }
    setSdrLoading(true);

    try {
      let companyName = sdrTarget;
      let contextUrl = "";
      if (sdrTarget.includes('.') && !sdrTarget.includes(' ')) {
        contextUrl = sdrTarget;
        companyName = sdrTarget.replace(/^https?:\/\//, '').replace(/^www\./, '').split('.')[0];
      }

      const { data, error } = await supabase.functions.invoke('sdr-engine', {
        body: {
          companyName: companyName,
          contextUrl: contextUrl,
          customPrompt: sdrPrompt
        }
      });

      if (error) throw new Error(error.message);
      if (data && data.error) throw new Error(data.error);

      setSdrTarget("");
      fetchSdrLeads();
    } catch (err: any) {
      alert("❌ Erreur de génération IA : " + err.message);
    } finally {
      setSdrLoading(false);
    }
  };

  // ✅ SDR : ENVOI D'UN COURRIEL INDIVIDUEL
  const handleSendSdrEmail = async (lead: any) => {
    let targetEmail = lead.email;

    if (!targetEmail) {
      targetEmail = prompt(`Adresse courriel manquante pour ${lead.company_name}.\nÀ quelle adresse souhaitez-vous envoyer ce courriel ?`);
      if (!targetEmail) return;
    }

    if (!confirm(`Confirmez-vous l'envoi de cette campagne à ${targetEmail} ?`)) return;

    try {
      const { data, error } = await supabase.functions.invoke('send-sdr-email', {
        body: {
          leadId: lead.id,
          targetEmail: targetEmail,
          emailContent: lead.email_draft,
          subject: `Opportunité locale Forfeo - ${lead.company_name}`
        }
      });

      if (error) throw new Error(error.message);
      if (data && data.error) throw new Error(data.error);

      alert("✅ Courriel expédié avec succès via Resend !");
      fetchSdrLeads();
    } catch (err: any) {
      alert("❌ Erreur d'envoi : " + err.message);
    }
  };

  // ✅ SDR : ENVOI GROUPÉ DE TOUS LES BROUILLONS
  const handleSendAllSdrEmails = async () => {
    const drafts = sdrLeads.filter(lead => lead.status === 'drafted');

    if (drafts.length === 0) {
      return alert("Aucun courriel en attente d'envoi.");
    }

    if (!confirm(`Êtes-vous sûr de vouloir envoyer ${drafts.length} courriels d'un coup ?\n(Les cibles sans adresse courriel seront ignorées).`)) {
      return;
    }

    setSdrLoading(true);
    let sentCount = 0;

    for (const lead of drafts) {
      if (!lead.email) continue;

      try {
        const { error } = await supabase.functions.invoke('send-sdr-email', {
          body: {
            leadId: lead.id,
            targetEmail: lead.email,
            emailContent: lead.email_draft,
            subject: `Opportunité locale Forfeo - ${lead.company_name}`
          }
        });
        if (!error) sentCount++;
      } catch (err) {
        console.error(`Erreur d'envoi pour ${lead.company_name}:`, err);
      }
    }

    setSdrLoading(false);
    alert(`✅ Terminé ! ${sentCount} courriels ont été expédiés.`);
    fetchSdrLeads();
  };

  // ✅ SDR : AJOUT MANUEL
  const handleManualSdrAdd = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newSdrCompany) return;
    const slug = newSdrCompany.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
    const { error } = await supabase.from('sdr_leads').insert([
      { company_name: newSdrCompany, email: newSdrEmail, demo_slug: slug, status: 'drafted', email_draft: 'Bonjour,\n\nDécouvrez votre démo personnalisée Forfeo.' }
    ]);
    if (!error) {
      setNewSdrCompany("");
      setNewSdrEmail("");
      fetchSdrLeads();
      alert("Lead ajouté manuellement !");
    } else alert("Erreur: " + error.message);
  };

  // ✅ SDR : SUPPRESSION ET ÉDITION
  const handleDeleteSdrLead = async (id: string) => {
    if (!confirm("Supprimer définitivement ce lead ?")) return;
    const { error } = await supabase.from('sdr_leads').delete().eq('id', id);
    if (!error) fetchSdrLeads();
  };

  const handleEditSdrLead = async (lead: any) => {
    const newEmail = prompt(`Modifier l'email pour ${lead.company_name}`, lead.email || "");
    if (newEmail !== null) {
      await supabase.from('sdr_leads').update({ email: newEmail }).eq('id', lead.id);
      fetchSdrLeads();
    }
  };

  // --- FETCHERS HABITAT ---
  const fetchHabitatStats = async () => {
    try {
      const { count: prosCount } = await supabase.from('forfeo_pros').select('*', { count: 'exact', head: true }).eq('subscription_status', 'active');
      const { count: listingsCount } = await supabase.from('habitat_listings').select('*', { count: 'exact', head: true });
      const { data: apps } = await supabase.from('habitat_applications').select('status, tenant_signed_at, landlord_signed_at');
      const sealedLeases = apps ? apps.filter(a => a.status === 'approved' || a.tenant_signed_at || a.landlord_signed_at).length : 0;
      const { count: ticketsCount } = await supabase.from('habitat_maintenance_tickets').select('*', { count: 'exact', head: true }).neq('status', 'resolved');

      const { data: screeningsData, count: screeningsCount } = await supabase
        .from('habitat_screenings')
        .select('*, landlord:habitat_profiles!habitat_screenings_landlord_id_fkey(full_name, email)', { count: 'exact' })
        .order('created_at', { ascending: false });

      if (screeningsData) setScreenings(screeningsData as any[]);

      const { count: rentCount } = await supabase.from('habitat_rent_payments').select('*', { count: 'exact', head: true });

      setHabitatStats({
        activePros: prosCount || 0,
        totalListings: listingsCount || 0,
        sealedLeases: sealedLeases,
        activeTickets: ticketsCount || 0,
        totalScreenings: screeningsCount || 0,
        rentPaymentsCount: rentCount || 0
      });
    } catch (e) {
      console.error("Erreur Stats Habitat", e);
    }
  };

  const fetchHabitatProfiles = async () => {
    const { data, error } = await supabase.from('habitat_profiles').select('*').order('created_at', { ascending: false });
    if (error) console.error("Erreur de chargement Habitat:", error);
    if (data) setHabitatProfiles(data as HabitatProfile[]);
  };

  const toggleHabitatApproval = async (id: string, currentStatus: boolean) => {
    if (!window.confirm(currentStatus ? "Suspendre ce compte Habitat ?" : "Valider ce compte Habitat ?")) return;
    const { error } = await supabase.rpc('admin_set_habitat_approval', {
      p_profile_id: id,
      p_is_approved: !currentStatus
    });

    if (!error) {
      setHabitatProfiles(
        habitatProfiles.map((profile) =>
          profile.id === id
            ? { ...profile, is_approved: !currentStatus }
            : profile
        )
      );
    }
  };

  const deleteHabitatProfile = async (id: string) => {
    if (!window.confirm("Supprimer ce profil Habitat ?")) return;
    const { error } = await supabase.from('habitat_profiles').delete().eq('id', id);
    if (!error) setHabitatProfiles(habitatProfiles.filter(p => p.id !== id));
  };

  const handleUploadScreeningReport = async (e: React.ChangeEvent<HTMLInputElement>, screening: Screening) => {
    if (!e.target.files || e.target.files.length === 0) return;
    setUploadingScreeningId(screening.id);
    const file = e.target.files[0];

    try {
      const fileExt = file.name.split('.').pop();
      const fileName = `${screening.landlord_id}/enquete_${screening.tenant_email}_${Date.now()}.${fileExt}`;

      const { error: uploadError } = await supabase.storage.from('landlord_vault').upload(fileName, file);
      if (uploadError) throw uploadError;

      const { data: { publicUrl } } = supabase.storage.from('landlord_vault').getPublicUrl(fileName);

      await supabase.from('landlord_vault').insert([{
        landlord_id: screening.landlord_id,
        document_type: 'enquete',
        file_url: publicUrl,
        file_name: `Enquête Premium - ${screening.tenant_email}.pdf`
      }]);

      await supabase.from('habitat_screenings').update({ status: 'completed' }).eq('id', screening.id);

      await supabase.from('habitat_notifications').insert([{
        user_id: screening.landlord_id,
        title: 'Enquête de crédit terminée ! 📄',
        message: `Le rapport détaillé pour le candidat ${screening.tenant_email} est maintenant disponible dans votre Coffre-fort sécurisé.`,
        type: 'success'
      }]);

      alert('✅ Rapport téléversé ! Le propriétaire a été notifié.');
      fetchHabitatStats();
    } catch (error: any) {
      alert("Erreur lors de l'envoi : " + error.message);
    } finally {
      setUploadingScreeningId(null);
    }
  };

  const invokeAdminContent = async (
    body: Record<string, unknown>,
  ) => {
    const { data, error } =
      await supabase.functions.invoke(
        'admin-content',
        { body },
      );

    if (error || !data?.ok) {
      throw new Error(
        data?.error ||
        error?.message ||
        "Action administrateur impossible"
      );
    }

    return data;
  };

  // --- FETCHERS TUTORIELS / FAQ ---
  const fetchTutorials = async () => {
    try {
      const result = await invokeAdminContent({
        action: 'list_tutorials',
      });

      setTutorials(
        result.tutorials || []
      );
    } catch (error) {
      console.error(
        "Erreur chargement tutoriels",
        error,
      );
    }
  };

  const handleAddTutorial = async (
    event: React.FormEvent,
  ) => {
    event.preventDefault();

    try {
      const result = await invokeAdminContent({
        action: 'create_tutorial',
        tutorial: newTutorial,
      });

      setTutorials((current) => [
        result.tutorial,
        ...current,
      ]);

      setNewTutorial({
        title: '',
        content: '',
        video_url: '',
        category: 'Général',
      });

      alert(
        "Tutoriel/FAQ ajouté avec succès !"
      );
    } catch (error: any) {
      alert(
        "Erreur: " +
        (
          error?.message ||
          "Ajout impossible"
        )
      );
    }
  };

  const deleteTutorial = async (
    id: string,
  ) => {
    if (!confirm(
      "Voulez-vous supprimer cette FAQ / ce tutoriel ?"
    )) {
      return;
    }

    try {
      await invokeAdminContent({
        action: 'delete_tutorial',
        id,
      });

      setTutorials((current) =>
        current.filter(
          (tutorial) =>
            tutorial.id !== id
        )
      );
    } catch (error: any) {
      alert(
        "Erreur: " +
        (
          error?.message ||
          "Suppression impossible"
        )
      );
    }
  };

  // --- FETCHERS PRP ---
  const fetchPrps = async () => {
    const { data } = await supabase.from('prps').select('*').order('created_at', { ascending: false });
    if (data) setPrpsList(data);
  };

  const invokeAdminPayouts = async (
    body: Record<string, unknown>,
  ) => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session?.access_token) {
      throw new Error(
        "Session administrateur absente"
      );
    }

    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/admin-payouts`,
      {
        method: 'POST',
        headers: {
          Authorization:
            `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      },
    );

    const result = await response.json();

    if (!response.ok || !result?.ok) {
      throw new Error(
        result?.error ||
        "Action administrateur impossible"
      );
    }

    return result;
  };

  const fetchPrpPayouts = async () => {
    try {
      const result = await invokeAdminPayouts({
        action: 'list',
      });

      setPrpPayouts(
        result.prp_payouts || []
      );
    } catch (error) {
      console.error(
        "Erreur chargement paiements PRP",
        error,
      );
    }
  };

  const handleAddPrp = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newPrpEmail || !newPrpRegion) return;

    const { data: profile, error: profileErr } = await supabase
      .from('profiles')
      .select('id, email')
      .ilike('email', newPrpEmail.trim())
      .maybeSingle();

    if (profileErr || !profile) {
      return alert("Utilisateur introuvable. Il doit créer un compte Forfeo d'abord.");
    }

    const { error } = await supabase.rpc(
      'admin_review_prp_onboarding',
      {
        p_target_user_id: profile.id,
        p_decision: 'approve',
        p_region: newPrpRegion.trim(),
      },
    );

    if (error) {
      return alert("Erreur d'approbation PRP : " + error.message);
    }

    alert(`Le compte de ${profile.email} est maintenant PRP approuvé.`);
    setNewPrpEmail("");
    setNewPrpRegion("");
    await fetchPrps();
  };

  const updatePrp = async (
    id: string,
    newRegion: string,
    newRate: number,
    newStatus: string,
  ) => {
    void newRate;

    const prp = prpsList.find((row: any) => row.id === id);

    if (!prp?.user_id) {
      return alert("Utilisateur PRP introuvable.");
    }

    const { error } = await supabase.rpc(
      'admin_review_prp_onboarding',
      {
        p_target_user_id: prp.user_id,
        p_decision: newStatus === 'active' ? 'approve' : 'suspend',
        p_region: newRegion?.trim() || null,
      },
    );

    if (error) {
      return alert("Erreur PRP : " + error.message);
    }

    await fetchPrps();
  };

  const deletePrp = async (id: string) => {
    const prp = prpsList.find((row: any) => row.id === id);

    if (!prp?.user_id) {
      return alert("Utilisateur PRP introuvable.");
    }

    if (!window.confirm(
      "Suspendre ce PRP ? Aucune suppression destructive ne sera effectuée.",
    )) {
      return;
    }

    const { error } = await supabase.rpc(
      'admin_review_prp_onboarding',
      {
        p_target_user_id: prp.user_id,
        p_decision: 'suspend',
        p_region: prp.region || null,
      },
    );

    if (error) {
      return alert("Erreur PRP : " + error.message);
    }

    await fetchPrps();
  };

  // --- FETCHERS BIZ ---
  const fetchBusinesses = async () => {
    const { data } = await supabase.from('businesses').select('*').order('created_at', { ascending: false });
    if (data) setBusinesses(data);
  };

  const toggleApproval = async (
    id: string,
    currentStatus: boolean,
    bizData: any,
  ) => {
    const decision = currentStatus ? 'suspend' : 'approve';
    const confirmed = window.confirm(
      currentStatus
        ? 'Suspendre ce compte commerçant et retirer sa publication ?'
        : 'Approuver ce compte commerçant et activer son portail ?',
    );

    if (!confirmed) return;

    const reason = currentStatus
      ? window.prompt('Motif de la suspension (facultatif) :')
      : null;

    const { error } = await supabase.rpc(
      'admin_review_forfeo_merchant_onboarding',
      {
        p_business_id: id,
        p_decision: decision,
        p_reason: reason || null,
      },
    );

    if (error) {
      alert(`Action impossible : ${error.message}`);
      return;
    }

    if (!currentStatus) sendApprovalEmail(bizData);
    await fetchBusinesses();
  };

  const sendApprovalEmail = (biz: any) => {
    emailjs.send('service_7wujp7j', 'template_f2bbbfh', { to_email: biz.email, business_name: biz.name, message: "Compte validé !" }, (import.meta as any).env.VITE_EMAILJS_PUBLIC_KEY).catch(console.error);
  };

  const deleteBusiness = async (id: any) => {
    if (window.confirm("Supprimer ?")) {
      const { error } = await supabase.from('businesses').delete().eq('id', id);
      if (!error) setBusinesses(businesses.filter(b => b.id !== id));
    }
  };

  // --- AFFILIÉS ---
  const fetchAffiliates = async () => {
    const { data } = await supabase.from('affiliates').select('*').order('created_at', { ascending: false });
    if (data) setAffiliates(data);
  };

  const deleteAffiliate = async (id: string) => {
    if (!confirm("Supprimer cet affilié ? Cette action est irréversible.")) return;
    const { error } = await supabase.from('affiliates').delete().eq('id', id);
    if (!error) setAffiliates(prev => prev.filter(a => a.id !== id));
  };

  const toggleAffiliateStatus = async (affiliate: Affiliate) => {
    const newStatus = affiliate.status === 'active' ? 'banned' : 'active';
    if (!confirm(`Changer statut ?`)) return;
    const { error } = await supabase.from('affiliates').update({ status: newStatus }).eq('id', affiliate.id);
    if (!error) setAffiliates(prev => prev.map(a => a.id === affiliate.id ? { ...a, status: newStatus } : a));
  };

  const saveAffiliateChanges = async () => {
    if (!editingAffiliate) return;
    const { error } = await supabase.from('affiliates').update({ commission_percent: editingAffiliate.commission_percent, fixed_rate: editingAffiliate.fixed_rate, remuneration_mode: editingAffiliate.remuneration_mode }).eq('id', editingAffiliate.id);
    if (!error) { setAffiliates(prev => prev.map(a => a.id === editingAffiliate.id ? editingAffiliate : a)); setEditingAffiliate(null); alert("✅ Modifié !"); }
  };

  // --- PAYOUTS ---
  const fetchPayouts = async () => {
    try {
      const result = await invokeAdminPayouts({
        action: 'list',
      });

      setPayouts(
        result.affiliate_payouts || []
      );
    } catch (error) {
      console.error(
        "Erreur chargement paiements affiliés",
        error,
      );
    }
  };

  const executePayout = async (payout: any) => {
    if (!confirm(`⚠️ Confirmer le virement de ${payout.amount}$ pour cet affilié ?`)) return;
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/payout-affiliate`, {
        method: 'POST', headers: { 'Authorization': `Bearer ${session?.access_token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ payout_id: payout.id })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || "Erreur lors du virement");
      alert(`✅ Succès ! Virement Stripe ID: ${result.transfer_id}`);
      setPayouts(prev => prev.map(p => p.id === payout.id ? { ...p, status: 'paid' } : p));
    } catch (error: any) { alert("❌ Erreur Virement : " + error.message); }
  };

  const executePrpPayout = async (payout: any) => {
    if (
      !confirm(
        "Approuver ce règlement PRP ? Aucun transfert réel ne sera exécuté par cette action.",
      )
    ) {
      return;
    }

    try {
      const {
        data: sessionData,
      } =
        await supabase.auth.getSession();

      const token =
        sessionData.session
          ?.access_token;

      if (!token) {
        throw new Error(
          "Session administrateur requise",
        );
      }

      const response =
        await fetch(
          `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/admin-payouts`,
          {
            method:
              "POST",

            headers: {
              "Content-Type":
                "application/json",

              Authorization:
                `Bearer ${token}`,
            },

            body:
              JSON.stringify(
                {
                  action:
                    "approve",

                  payout_type:
                    "prp",

                  payout_id:
                    payout.id,

                  note:
                    "Approved by administrator; awaiting canonical processor settlement.",
                },
              ),
          },
        );

      const result =
        await response
          .json()
          .catch(
            () => ({}),
          );

      if (!response.ok) {
        throw new Error(
          result?.error ||
          "Impossible d'approuver le règlement PRP",
        );
      }

      setPrpPayouts(
        (current) =>
          current.map(
            (candidate) =>
              candidate.id ===
              payout.id
                ? {
                    ...candidate,

                    status:
                      "approved",

                    canonical_status:
                      "approved",

                    financial_source:
                      "giftshop_canonical",
                  }
                : candidate,
          ),
      );
    } catch (error) {
      console.error(
        "PRP payout approval error:",
        error,
      );

      alert(
        error instanceof Error
          ? error.message
          : "Impossible d'approuver le règlement PRP",
      );
    }
  };

  const rejectPrpPayout = async (
    id: string,
  ) => {
    if (!confirm(
      "Refuser cette demande de retrait ? Les fonds seront recrédités au PRP."
    )) {
      return;
    }

    try {
      await invokeAdminPayouts({
        action: 'reject',
        payout_type: 'prp',
        payout_id: id,
      });

      setPrpPayouts((current) =>
        current.map((payout) =>
          payout.id === id
            ? {
                ...payout,
                status: 'rejected',
              }
            : payout
        )
      );
    } catch (error: any) {
      alert(
        "❌ Erreur : " +
        (
          error?.message ||
          "Refus impossible"
        )
      );
    }
  };

  // --- VIDEOS ---
  const fetchVideos = async () => {
    try {
      const result = await invokeAdminContent({
        action: 'list_videos',
      });

      setHomeVideos(
        result.videos || []
      );
    } catch (error) {
      console.error(
        "Erreur chargement vidéos",
        error,
      );
    }
  };
  const handleVideoUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (
      !event.target.files ||
      event.target.files.length === 0
    ) {
      return;
    }

    const file = event.target.files[0];

    if (!file.type.startsWith('video/')) {
      alert(
        "Veuillez sélectionner une vidéo."
      );
      return;
    }

    if (file.size > 50 * 1024 * 1024) {
      alert("Vidéo trop lourde.");
      return;
    }

    setUploadingVideo(true);

    let uploadedObjectPath = '';

    try {
      const fileExtension =
        file.name.split('.').pop() ||
        'mp4';

      uploadedObjectPath =
        `${Date.now()}.${fileExtension}`;

      const { error: uploadError } =
        await supabase.storage
          .from('videos')
          .upload(
            uploadedObjectPath,
            file,
          );

      if (uploadError) {
        throw uploadError;
      }

      const {
        data: { publicUrl },
      } = supabase.storage
        .from('videos')
        .getPublicUrl(
          uploadedObjectPath,
        );

      const result =
        await invokeAdminContent({
          action: 'create_video',
          video: {
            title:
              newVideoTitle ||
              'Nouvelle vidéo',
            video_url: publicUrl,
          },
        });

      setHomeVideos((current) => [
        result.video,
        ...current,
      ]);

      setNewVideoTitle('');
      alert("Vidéo ajoutée !");
    } catch (error: any) {
      if (uploadedObjectPath) {
        await supabase.storage
          .from('videos')
          .remove([
            uploadedObjectPath,
          ])
          .catch(() => undefined);
      }

      alert(
        "Erreur upload: " +
        (
          error?.message ||
          "Erreur inconnue"
        )
      );
    } finally {
      setUploadingVideo(false);
      event.target.value = '';
    }
  };
  const deleteVideo = async (
    id: string,
    videoUrl: string,
  ) => {
    if (!confirm(
      "Supprimer cette vidéo ?"
    )) {
      return;
    }

    try {
      await invokeAdminContent({
        action: 'delete_video',
        id,
      });

      try {
        const parsedUrl =
          new URL(videoUrl);

        const storageMarker =
          '/storage/v1/object/public/videos/';

        const markerIndex =
          parsedUrl.pathname.indexOf(
            storageMarker
          );

        if (markerIndex >= 0) {
          const objectPath =
            decodeURIComponent(
              parsedUrl.pathname.slice(
                markerIndex +
                  storageMarker.length
              )
            );

          if (objectPath) {
            await supabase.storage
              .from('videos')
              .remove([objectPath]);
          }
        }
      } catch (storageError) {
        console.warn(
          "Vidéo supprimée de la base, "
            + "mais nettoyage Storage impossible",
          storageError,
        );
      }

      setHomeVideos((current) =>
        current.filter(
          (video) => video.id !== id
        )
      );
    } catch (error: any) {
      alert(
        "Erreur: " +
        (
          error?.message ||
          "Suppression impossible"
        )
      );
    }
  };

  // --- ANNONCES ---
  const fetchAnnouncements = async () => {
    try {
      const result = await invokeAdminContent({
        action: 'list_announcements',
      });

      setAnnouncements(
        result.announcements || []
      );
    } catch (error) {
      console.error(
        "Erreur chargement annonces",
        error,
      );
    }
  };
  const handlePostAnnouncement = async (
    event: React.FormEvent,
  ) => {
    event.preventDefault();

    try {
      const result = await invokeAdminContent({
        action: 'create_announcement',
        announcement: newAnnouncement,
      });

      setAnnouncements((current) => [
        result.announcement,
        ...current,
      ]);

      setNewAnnouncement({
        title: '',
        content: '',
        tag: 'INFO',
      });
    } catch (error: any) {
      alert(
        "Erreur: " +
        (
          error?.message ||
          "Publication impossible"
        )
      );
    }
  };
  const deleteAnnouncement = async (
    id: string,
  ) => {
    try {
      await invokeAdminContent({
        action: 'delete_announcement',
        id,
      });

      setAnnouncements((current) =>
        current.filter(
          (announcement) =>
            announcement.id !== id
        )
      );
    } catch (error: any) {
      alert(
        "Erreur: " +
        (
          error?.message ||
          "Suppression impossible"
        )
      );
    }
  };

  // --- NEWSLETTER ---
  const fetchSubscribers = async () => {
    const { data, error } = await supabase.from('newsletter_subscribers').select('id, email, postal_code, created_at').order('created_at', { ascending: false });
    if (!error && data) setSubscribers(data as NewsletterSubscriber[]);
  };
  const deleteSubscriber = async (id: string) => {
    if (!confirm("Supprimer cet abonné ?")) return;
    const { error } = await supabase.from('newsletter_subscribers').delete().eq('id', id);
    if (!error) setSubscribers(prev => prev.filter(s => s.id !== id));
  };
  const fetchContent = async () => {
    const { data: d } = await supabase.from('last_call_deals').select('*, business:businesses(name)').gt('expires_at', new Date().toISOString());
    if (d) setDeals(d);
    const { data: p } = await supabase.from('shop_products').select('*, business:businesses(name)').eq('is_active', true);
    if (p) setProducts(p);
    const { data: a } = await supabase.from('accommodations').select('*, business:businesses(name)').eq('is_available', true);
    if (a) setAccommodations(a);
  };
  const toggleItemSelection = (item: any, type: string) => {
    const id = String(item.id);
    const exists = selectedItems.find(i => i.id === id && i.type === type);
    if (exists) setSelectedItems(prev => prev.filter(i => !(i.id === id && i.type === type)));
    else {
      const url = extractBestUrl(type, item);
      setSelectedItems(prev => [...prev, { type, id, url, title: item.title || item.name || 'Offre', price: String(item.discount_price || item.price || item.price_per_night || ''), image: item.image_url || '', business: item.business?.name || 'Partenaire', ctaLabel: ctaLabelForType(type) }]);
    }
  };
  const generateNewsletterContent = async () => {
    if (selectedItems.length === 0) return alert("Sélection vide !");
    setIsGenerating(true);
    const itemsContext = selectedItems.map(i => `- [${i.type}] ${i.title} (${i.price}$) | Partenaire: ${i.business} | Lien: ${i.url}`).join('\n');
    try {
      const { data: newsletterData, error: newsletterError } = await supabase.functions.invoke(
        'admin-newsletter-ai',
        {
          body: {
            items: selectedItems.map(item => ({
              type: item.type,
              title: item.title,
              price: item.price,
              business: item.business,
              url: item.url,
            })),
          },
        }
      );
      if (newsletterError || newsletterData?.success === false) {
        throw new Error(
          newsletterData?.error ||
          newsletterError?.message ||
          "Erreur lors de la génération sécurisée."
        );
      }
      const aiRaw = newsletterData?.html || "";
      const cleanedHtml = sanitizeAiNewsletterHtml(aiRaw);
      if (!cleanedHtml) throw new Error("La génération a retourné un contenu vide.");
      setNewsletterHtml(cleanedHtml);
      if (!newsletterSubject?.trim()) setNewsletterSubject("🌲 Pépites locales Forfeo !");
    } catch (e: any) { alert(e.message || "Erreur."); } finally { setIsGenerating(false); }
  };
  const sendCampaign = async () => {
    const all = [...new Set([...subscribers.map(s => (s.email || '').trim()).filter(Boolean), ...manualRecipientsList])];
    if (!newsletterHtml || all.length === 0) return alert("Pas de contenu/destinataires");
    if (!confirm(`Envoyer à ${all.length} ?`)) return;
    setIsSending(true);
    try {
      const finalHtml = sanitizeAiNewsletterHtml(newsletterHtml);
      await supabase.functions.invoke('send-newsletter', { body: { subject: newsletterSubject || "🌲 Pépites locales Forfeo !", htmlContent: finalHtml, recipients: all } });
      alert("Envoyé !"); setSelectedItems([]); setNewsletterHtml("");
    } catch (e: any) { alert(e.message); } finally { setIsSending(false); }
  };

  const handleUpdatePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setPasswordMessage(null);
    if (newPassword !== confirmPassword) return setPasswordMessage({ type: 'error', text: "Mots de passe différents." });
    const { error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) setPasswordMessage({ type: 'error', text: error.message });
    else { setPasswordMessage({ type: 'success', text: "Mis à jour !" }); setNewPassword(""); setConfirmPassword(""); }
  };
  const handleLogout = async () => { await supabase.auth.signOut(); navigate('/login'); };

  const filteredBusinesses = businesses.filter(b => (b.name || '').toLowerCase().includes(searchTerm.toLowerCase()));

  const adminTabs = [
    { id: 'businesses', icon: <FaStore />, label: 'Entreprises' },
    { id: 'ordersVouchers', icon: <FaChartPie />, label: 'Paiements' },
    { id: 'experienceReviews', icon: <FaStar />, label: 'Avis' },
    { id: 'emailSequences', icon: <FaPaperPlane />, label: 'Emails' },
    { id: 'marketingAnalytics', icon: <FaChartPie />, label: 'Analytics' },
    { id: 'lastCallReservations', icon: <FaCalendarCheck />, label: 'Last Call' },
    { id: 'combos', icon: <FaHandshake />, label: 'Combos' },
    { id: 'commissions', icon: <FaPercentage />, label: 'Commissions' },
    { id: 'habitat', icon: <FaHome />, label: 'Habitat' },
    { id: 'sdr', icon: <FaRobot />, label: 'Agent SDR' },
    { id: 'videos', icon: <FaVideo />, label: 'Vidéos' },
    { id: 'affiliates', icon: <FaHandshake />, label: 'Affiliés' },
    { id: 'prps', icon: <FaUserTie />, label: 'Directeurs' },
    { id: 'partnerCandidates', icon: <FaHandshake />, label: 'Candidats PRP' },
    { id: 'merchantOnboarding', icon: <FaStore />, label: 'Onboarding commerces' },
    { id: 'commercialControlTower', icon: <FaStore />, label: 'Tour commerciale' },
    { id: 'productionValidation', icon: <FaStore />, label: 'Validation production' },
    { id: 'payouts', icon: <FaMoneyBillWave />, label: 'Finances' },
    { id: 'announcements', icon: <FaBullhorn />, label: 'Actus' },
    { id: 'newsletter', icon: <FaEnvelopeOpenText />, label: 'Newsletter' },
    { id: 'tutorials', icon: <FaBookOpen />, label: 'Tutoriels' },
    { id: 'security', icon: <FaShieldAlt />, label: 'Sécurité' },
    { id: 'accountLifecycle', icon: <FaShieldAlt />, label: 'Gestion du compte' },
  ];

  const scrollAdminTabs = (direction: 'left' | 'right') => {
    const container = adminTabsScrollRef.current;
    if (!container) return;
    const distance = Math.max(260, Math.floor(container.clientWidth * 0.75));
    container.scrollBy({ left: direction === 'left' ? -distance : distance, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900">
      <Header />
      <div className="container mx-auto px-4 py-10 pt-24">

        {/* MODALE ÉDITION AFFILIÉ */}
        {editingAffiliate && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-sm animate-in fade-in">
            <div className="bg-white rounded-3xl w-full max-w-lg shadow-2xl overflow-hidden relative p-8">
              <button onClick={() => setEditingAffiliate(null)} className="absolute top-4 right-4 bg-slate-100 p-2 rounded-full hover:bg-slate-200"><FaTimes /></button>
              <h3 className="text-2xl font-black mb-6 text-slate-900 flex items-center gap-2"><FaHandshake className="text-purple-600" /> Modifier l'affilié</h3>
              <div className="space-y-6">
                <div><label className="block text-xs font-black uppercase text-slate-400 mb-2">Code</label><div className="p-4 bg-slate-100 rounded-xl font-mono font-bold text-slate-600">{editingAffiliate.referral_code}</div></div>
                <div className="flex gap-4">
                  <button onClick={() => setEditingAffiliate({ ...editingAffiliate, remuneration_mode: 'commission' })} className={`flex-1 py-3 rounded-xl font-bold border-2 ${editingAffiliate.remuneration_mode === 'commission' ? 'border-purple-600 bg-purple-50 text-purple-700' : 'border-slate-200'}`}>% Comm.</button>
                  <button onClick={() => setEditingAffiliate({ ...editingAffiliate, remuneration_mode: 'fixed' })} className={`flex-1 py-3 rounded-xl font-bold border-2 ${editingAffiliate.remuneration_mode === 'fixed' ? 'border-purple-600 bg-purple-50 text-purple-700' : 'border-slate-200'}`}>$ Fixe</button>
                </div>
                <input type="number" value={editingAffiliate.remuneration_mode === 'commission' ? editingAffiliate.commission_percent : editingAffiliate.fixed_rate} onChange={(e) => editingAffiliate.remuneration_mode === 'commission' ? setEditingAffiliate({ ...editingAffiliate, commission_percent: parseFloat(e.target.value) }) : setEditingAffiliate({ ...editingAffiliate, fixed_rate: parseFloat(e.target.value) }) } className="w-full p-4 border-2 border-slate-200 rounded-xl font-bold text-xl" />
                <button onClick={saveAffiliateChanges} className="w-full bg-purple-600 text-white py-4 rounded-xl font-black uppercase"><FaSave /> Enregistrer</button>
              </div>
            </div>
          </div>
        )}

        {/* HEADER */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-8 gap-6">
          <div>
            <h1 className="text-3xl font-black text-slate-900 flex items-center gap-3"><FaShieldAlt className="text-blue-600" /> Admin Dashboard</h1>
            <p className="text-xs text-slate-500 mt-2">Compte : <span className="font-bold">{adminEmail ?? "—"}</span></p>
          </div>
          <div className="flex gap-3">
            <button onClick={() => navigate('/')} className="bg-white px-5 py-2.5 rounded-xl font-bold border border-slate-200 hover:bg-slate-50 transition">Retour Site</button>
            <button onClick={handleLogout} className="bg-slate-900 text-white px-5 py-2.5 rounded-xl font-bold flex items-center gap-2 hover:bg-slate-800 transition"><FaSignOutAlt /> Déconnexion</button>
          </div>
        </div>

        <div className="mb-8 border-b border-slate-200 pb-4">
          <div className="mb-3 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <p className="text-[10px] font-black uppercase tracking-[0.28em] text-slate-400">Navigation admin</p>
              <p className="text-xs font-semibold text-slate-500">Fais défiler pour accéder à tous les modules.</p>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => scrollAdminTabs('left')}
                className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-lg font-black text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700"
                aria-label="Faire défiler les onglets admin vers la gauche"
              >
                ‹
              </button>
              <button
                type="button"
                onClick={() => scrollAdminTabs('right')}
                className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-lg font-black text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700"
                aria-label="Faire défiler les onglets admin vers la droite"
              >
                ›
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-8 bg-gradient-to-r from-slate-50 to-transparent" />
            <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-8 bg-gradient-to-l from-slate-50 to-transparent" />
            <div
              ref={adminTabsScrollRef}
              className="admin-tabs-scroll flex w-full snap-x gap-2 overflow-x-auto overflow-y-hidden scroll-smooth px-2 pb-4 pt-1 md:gap-3"
              style={{
                WebkitOverflowScrolling: 'touch',
                scrollbarWidth: 'thin',
                scrollbarColor: '#cbd5e1 transparent',
              }}
            >
              {adminTabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() =>
                    tab.id === 'accountLifecycle'
                      ? navigate('/gestion-compte')
                      : setActiveTab(tab.id as any)
                  }
                  className={`snap-start shrink-0 flex min-h-[76px] w-[82px] flex-col items-center justify-center gap-1.5 rounded-2xl border p-3 font-bold transition-all duration-300 md:w-[96px] ${
                    activeTab === tab.id
                      ? 'bg-slate-900 border-slate-900 text-white shadow-xl shadow-slate-900/15 scale-[1.03]'
                      : 'bg-white border-slate-200 text-slate-400 shadow-sm hover:-translate-y-0.5 hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700'
                  }`}
                  aria-pressed={activeTab === tab.id}
                >
                  <div className="text-xl md:text-2xl">{tab.icon}</div>
                  <span className="text-center text-[11px] leading-tight md:text-[10px]">{tab.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* 1. ENTREPRISES */}
        {activeTab === 'businesses' && (
          <>
            <div className="bg-white p-4 rounded-2xl border border-slate-200 mb-6 flex items-center gap-3 shadow-sm">
              <FaSearch className="text-slate-400 ml-2" />
              <input type="text" placeholder="Rechercher..." className="w-full outline-none font-medium text-slate-700" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </div>
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
              <div className="overflow-x-auto">
                <div className="min-w-[640px]">
                  <table className="w-full text-left">
                <thead className="bg-slate-50 border-b border-slate-200 text-slate-500">
                  <tr><th className="p-4 text-xs font-black uppercase">Nom</th><th className="p-4 text-xs font-black uppercase">Statut</th><th className="p-4 text-right text-xs font-black uppercase">Action</th></tr>
                </thead>
                <tbody>
                  {filteredBusinesses.map((biz) => (
                    <tr key={biz.id} className="border-b border-slate-50 hover:bg-slate-50">
                      <td className="p-4"><div className="font-bold text-slate-800">{biz.name}</div><div className="text-xs text-slate-400">{biz.email}</div></td>
                      <td className="p-4">
                        {biz.is_approved ? <span className="text-green-600 font-bold text-xs bg-green-100 px-2 py-1 rounded flex items-center w-fit gap-1"><FaCheck size={10} /> Validé</span> : <span className="text-amber-600 font-bold text-xs bg-amber-100 px-2 py-1 rounded flex items-center w-fit gap-1"><FaClock size={10} /> Attente</span>}
                      </td>
                      <td className="p-4 text-right">
                        <button
                          onClick={() =>
                            toggleApproval(
                              biz.id,
                              biz.is_approved,
                              biz,
                            )
                          }
                          className="mr-3 text-blue-600 font-bold text-xs underline"
                        >
                          {biz.is_approved ? 'Suspendre' : 'Approuver'}
                        </button>
                        <button onClick={() => deleteBusiness(biz.id)} className="text-slate-400 hover:text-red-500"><FaTrash /></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
                </div>
              </div>
            </div>
          </>
        )}

        {/* CENTRE PAIEMENTS & VOUCHERS */}
        {activeTab === 'ordersVouchers' && (
          <AdminOrdersVouchers />
        )}

        {/* CENTRE AVIS APRÈS EXPÉRIENCE */}
        {activeTab === 'experienceReviews' && (
          <AdminExperienceReviews />
        )}

        {/* CENTRE SÉQUENCES EMAILS CLIENTS */}
        {activeTab === 'emailSequences' && (
          <AdminEmailSequences />
        )}

        {/* CENTRE ANALYTICS MARKETING */}
        {activeTab === 'marketingAnalytics' && (
          <AdminMarketingAnalytics />
        )}

        {/* CENTRE RÉSERVATIONS LAST CALL */}
        {activeTab === 'lastCallReservations' && (
          <AdminLastCallReservations />
        )}

        {/* CENTRE COMBOS COLLABORATIFS */}
        {activeTab === 'combos' && (
          <AdminCombos />
        )}

        {/* CENTRE COMMISSIONS & REVENUS FORFEO */}
        {activeTab === 'commissions' && (
          <AdminCommissionSettings />
        )}

        {/* ✅ NOUVEL ONGLET HABITAT (SUPER ADMIN) */}
        {activeTab === 'habitat' && (
          <div className="animate-in fade-in space-y-8">

            {/* KPI CARDS (Métriques Globales) */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">

              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-amber-100 text-amber-600 flex items-center justify-center shrink-0">
                  <FaDollarSign size={24} />
                </div>
                <div>
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">MRR Artisans</p>
                  <p className="text-2xl font-black text-slate-900">{(habitatStats.activePros * 29.99).toFixed(2)} $</p>
                  <p className="text-xs text-slate-500 font-bold">{habitatStats.activePros} abonnements actifs</p>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-teal-100 text-teal-600 flex items-center justify-center shrink-0">
                  <FaFileSignature size={24} />
                </div>
                <div>
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Baux Scellés</p>
                  <p className="text-2xl font-black text-slate-900">{habitatStats.sealedLeases}</p>
                  <p className="text-xs text-slate-500 font-bold">Sur {habitatStats.totalListings} annonces actives</p>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-blue-100 text-blue-600 flex items-center justify-center shrink-0">
                  <FaHardHat size={24} />
                </div>
                <div>
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Maintenance</p>
                  <p className="text-2xl font-black text-slate-900">{habitatStats.activeTickets}</p>
                  <p className="text-xs text-slate-500 font-bold">Interventions en cours</p>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-purple-100 text-purple-600 flex items-center justify-center shrink-0">
                  <FaMapMarkedAlt size={24} />
                </div>
                <div>
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Vol. Enquêtes</p>
                  <p className="text-2xl font-black text-slate-900">{(habitatStats.totalScreenings * 54.99).toFixed(2)} $</p>
                  <p className="text-xs text-slate-500 font-bold">{habitatStats.totalScreenings} enquêtes (Premium)</p>
                </div>
              </div>

            </div>

            {/* ✅ NOUVELLE SECTION : GESTION DES ENQUÊTES DE CRÉDIT PREMIUM */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden mt-8">
              <div className="p-6 border-b border-slate-100 bg-purple-50 flex justify-between items-center">
                <div>
                  <h3 className="font-black text-purple-900 flex items-center gap-2"><FaMapMarkedAlt className="text-purple-600" /> Conciergerie - Enquêtes de crédit</h3>
                  <p className="text-xs text-purple-700 mt-1 font-bold">Téléversez les rapports d'enquêtes directement dans le coffre-fort des propriétaires (Facturé 54,99$).</p>
                </div>
              </div>
              {screenings.length === 0 ? (
                <div className="p-5 md:p-10 text-center text-slate-400 font-bold">Aucune demande d'enquête récente.</div>
              ) : (
                <div className="overflow-x-auto">
                  <div className="min-w-[900px]">
                    <table className="w-full text-left">
                  <thead className="bg-slate-50 border-b border-slate-200 text-slate-500">
                    <tr>
                      <th className="p-4 text-xs font-black uppercase">Date</th>
                      <th className="p-4 text-xs font-black uppercase">Propriétaire</th>
                      <th className="p-4 text-xs font-black uppercase">Candidat (Locataire)</th>
                      <th className="p-4 text-xs font-black uppercase">Statut</th>
                      <th className="p-4 text-right text-xs font-black uppercase">Rapport PDF</th>
                    </tr>
                  </thead>
                  <tbody>
                    {screenings.map((screening) => (
                      <tr key={screening.id} className="border-b border-slate-50 hover:bg-slate-50">
                        <td className="p-4 text-sm font-bold text-slate-600">{new Date(screening.created_at).toLocaleDateString()}</td>
                        <td className="p-4">
                          <div className="font-bold text-slate-800">{screening.landlord?.full_name || 'Inconnu'}</div>
                          <div className="text-xs text-slate-400">{screening.landlord?.email}</div>
                        </td>
                        <td className="p-4 font-bold text-slate-800">{screening.tenant_email}</td>
                        <td className="p-4">
                          {screening.status === 'completed' ? (
                            <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-black">Terminé</span>
                          ) : (
                            <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-black animate-pulse">En attente</span>
                          )}
                        </td>
                        <td className="p-4 text-right">
                          {screening.status === 'completed' ? (
                            <span className="text-slate-400 text-xs font-bold"><FaCheckCircle className="inline text-green-500 mr-1"/> Envoyé</span>
                          ) : (
                            <label className={`cursor-pointer inline-flex items-center gap-2 bg-slate-900 text-white px-4 py-2 rounded-xl text-xs font-black uppercase tracking-widest hover:bg-slate-800 transition ${uploadingScreeningId === screening.id ? 'opacity-50' : ''}`}>
                              {uploadingScreeningId === screening.id ? <FaSpinner className="animate-spin" size={14} /> : <FaCloudUploadAlt size={14} />}
                              {uploadingScreeningId === screening.id ? 'Envoi...' : 'Upload PDF'}
                              <input
                                type="file"
                                accept="application/pdf"
                                className="hidden"
                                onChange={(e) => handleUploadScreeningReport(e, screening)}
                                disabled={uploadingScreeningId === screening.id}
                              />
                            </label>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                  </div>
                </div>
              )}
            </div>

            {/* TABLEAU DES UTILISATEURS HABITAT */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
              <div className="p-6 border-b border-slate-100 bg-teal-50 flex justify-between items-center">
                <h3 className="font-black text-teal-900 flex items-center gap-2"><FaHome className="text-teal-600" /> Gestion des Utilisateurs Habitat</h3>
              </div>
              {habitatProfiles.length === 0 ? (
                <div className="p-5 md:p-10 text-center text-slate-400 font-bold">Aucun profil Habitat trouvé.</div>
              ) : (
                <div className="overflow-x-auto">
                  <div className="min-w-[760px]">
                    <table className="w-full text-left">
                  <thead className="bg-slate-50 border-b border-slate-200 text-slate-500">
                    <tr><th className="p-4 text-xs font-black uppercase">Nom & Email</th><th className="p-4 text-xs font-black uppercase">Type</th><th className="p-4 text-xs font-black uppercase">Statut</th><th className="p-4 text-right text-xs font-black uppercase">Action</th></tr>
                  </thead>
                  <tbody>
                    {habitatProfiles.map((profile) => (
                      <tr key={profile.id} className="border-b border-slate-50 hover:bg-slate-50">
                        <td className="p-4">
                          <div className="font-bold text-slate-800">{profile.full_name}</div>
                          <div className="text-xs text-slate-400">{profile.email}</div>
                        </td>
                        <td className="p-4">
                          {profile.role === 'landlord'
                            ? <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs font-bold">Propriétaire</span>
                            : <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded text-xs font-bold">Locataire</span>}
                        </td>
                        <td className="p-4">
                          {profile.is_approved
                            ? <span className="text-green-600 font-bold text-xs bg-green-100 px-2 py-1 rounded flex items-center w-fit gap-1"><FaCheck size={10} /> Validé</span>
                            : <span className="text-amber-600 font-bold text-xs bg-amber-100 px-2 py-1 rounded flex items-center w-fit gap-1"><FaClock size={10} /> Attente</span>}
                        </td>
                        <td className="p-4 text-right flex justify-end gap-2">
                          <button onClick={() => toggleHabitatApproval(profile.id, profile.is_approved)} className="bg-teal-50 text-teal-600 px-3 py-1 rounded font-bold text-xs hover:bg-teal-100">
                            {profile.is_approved ? 'Suspendre' : 'Valider'}
                          </button>
                          <button onClick={() => deleteHabitatProfile(profile.id)} className="text-slate-400 hover:text-red-500 p-1"><FaTrash /></button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                  </div>
                </div>
              )}
            </div>

          </div>
        )}

        {/* NOUVEL ONGLET : GESTION DES PRP */}
        {activeTab === 'prps' && (
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
              <h3 className="font-black text-slate-900 mb-4 flex items-center gap-2"><FaPlus className="text-indigo-600" /> Promouvoir un utilisateur en PRP</h3>
              <form onSubmit={handleAddPrp} className="flex flex-col md:flex-row gap-4">
                <input type="email" placeholder="Email du compte Forfeo existant..." required value={newPrpEmail} onChange={e => setNewPrpEmail(e.target.value)} className="flex-1 p-3 rounded-xl border border-slate-200 outline-none focus:border-indigo-500" />
                <input type="text" placeholder="Région assignée" required value={newPrpRegion} onChange={e => setNewPrpRegion(e.target.value)} className="flex-1 p-3 rounded-xl border border-slate-200 outline-none focus:border-indigo-500" />
                <button type="submit" className="bg-indigo-600 text-white px-8 py-3 rounded-xl font-bold hover:bg-indigo-700 transition shadow-md">Ajouter ce PRP</button>
              </form>
            </div>
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
              <div className="p-6 border-b border-slate-100 bg-slate-50 flex justify-between items-center">
                <h3 className="font-black text-slate-900 flex items-center gap-2"><FaBuilding className="text-indigo-600" /> Présidents Régionaux Partenaires actuels</h3>
              </div>
              <div className="overflow-x-auto">
                <div className="min-w-[760px]">
                  <table className="w-full text-left">
                <thead className="bg-indigo-50 text-indigo-900">
                  <tr><th className="p-6 text-xs font-black uppercase">PRP (Email)</th><th className="p-6 text-xs font-black uppercase">Région (Modifiable)</th><th className="p-6 text-xs font-black uppercase">Commission (Modifiable)</th><th className="p-6 text-right text-xs font-black uppercase">Statut / Action</th></tr>
                </thead>
                <tbody>
                  {prpsList.map(prp => (
                    <tr key={prp.id} className="border-b border-slate-50 hover:bg-slate-50 transition">
                      <td className="p-6">
                        <div className="font-bold text-slate-800">{prp.full_name || "Nom inconnu"}</div>
                        <div className="text-xs text-slate-500">{prp.email || "Email inconnu"}</div>
                      </td>
                      <td className="p-6">
                        <input type="text" defaultValue={prp.region} onBlur={(e) => updatePrp(prp.id, e.target.value, prp.commission_rate * 100, prp.status)} className="w-40 p-2 border border-slate-200 rounded-lg text-sm font-bold bg-white" placeholder="Ex: Capitale-Nationale" />
                      </td>
                      <td className="p-6">
                        <input type="number" defaultValue={prp.commission_rate * 100} onBlur={(e) => updatePrp(prp.id, prp.region, Number(e.target.value), prp.status)} className="w-20 p-2 border border-slate-200 rounded-lg text-center font-bold bg-white" /> %
                      </td>
                      <td className="p-6 text-right">
                        <div className="flex justify-end gap-2 items-center">
                          {prp.status === 'pending' ? (
                            <button onClick={() => updatePrp(prp.id, prp.region, prp.commission_rate * 100, 'active')} className="bg-green-600 text-white px-4 py-2 rounded-xl text-xs font-black uppercase hover:bg-green-700 transition shadow-md">Approuver</button>
                          ) : (
                            <button onClick={() => updatePrp(prp.id, prp.region, prp.commission_rate * 100, 'pending')} className="bg-amber-100 text-amber-700 px-4 py-2 rounded-xl text-xs font-black uppercase hover:bg-amber-200 transition">Suspendre</button>
                          )}
                          <button onClick={() => deletePrp(prp.id)} className="bg-slate-100 text-slate-400 hover:text-red-500 hover:bg-red-50 p-2 rounded-lg transition" title="Supprimer">
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {prpsList.length === 0 && <tr><td colSpan={4} className="p-5 md:p-10 text-center text-slate-400 font-bold">Aucun compte PRP pour le moment. L'utilisateur doit s'inscrire depuis le site pour apparaître ici.</td></tr>}
                </tbody>
              </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* LOT 0F-9 — VALIDATION CANDIDATS PARTENAIRES PRP */}
        {activeTab === 'partnerCandidates' && (
          <AdminPartnerCandidatesPanel />
        )}

        {/* LOT 0F-11 — ONBOARDING COMMERCES */}
        {activeTab === 'merchantOnboarding' && (
          <AdminMerchantOnboardingReviewPanel />
        )}

        {/* LOT 0F-12 — TOUR DE CONTRÔLE COMMERCIALE */}
        {activeTab === 'commercialControlTower' && (
          <AdminCommercialControlTowerPanel />
        )}

        {/* LOT 0F-14 — CENTRE DE VALIDATION PRODUCTION */}
        {activeTab === 'productionValidation' && (
          <AdminProductionValidationCenterPanel />
        )}

        {/* FINANCES (PAYOUTS) */}
        {activeTab === 'payouts' && (
          <div className="space-y-8">
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
              <div className="p-6 border-b border-slate-100 bg-indigo-50 flex justify-between items-center">
                <h3 className="font-black text-indigo-900 flex items-center gap-2"><FaUserTie className="text-indigo-600" /> Virements Directeurs (PRP)</h3>
              </div>
              {prpPayouts.length === 0 ? (
                <div className="p-5 md:p-10 text-center text-slate-400 font-bold">Aucune demande de virement PRP.</div>
              ) : (
                <div className="overflow-x-auto">
                  <div className="min-w-[760px]">
                    <table className="w-full text-left">
                  <thead className="bg-slate-50 text-slate-500">
                    <tr><th className="p-6 text-xs font-black uppercase">Date</th><th className="p-6 text-xs font-black uppercase">Directeur</th><th className="p-6 text-xs font-black uppercase">Montant</th><th className="p-6 text-right text-xs font-black uppercase">Action</th></tr>
                  </thead>
                  <tbody>
                    {prpPayouts.map(pay => (
                      <tr key={pay.id} className="border-b border-slate-50 hover:bg-slate-50">
                        <td className="p-6 text-xs font-bold text-slate-500">{new Date(pay.created_at).toLocaleDateString()}</td>
                        <td className="p-6">
                          <div className="font-bold text-slate-900">{pay.prp?.full_name || pay.prp?.email || "Nom inconnu"}</div>
                          <div className="text-xs text-indigo-600 font-bold uppercase">{pay.prp?.region}</div>
                        </td>
                        <td className="p-6 font-black text-indigo-600 text-lg">{Number(pay.amount).toFixed(2)}$</td>
                        <td className="p-6 text-right">
                          {pay.status === 'pending' ? (
                            <div className="flex justify-end gap-2">
                              <button onClick={() => rejectPrpPayout(pay.id)} className="bg-red-50 text-red-600 px-3 py-2 rounded-xl font-bold hover:bg-red-100 transition"><FaTimes /></button>
                              <button onClick={() => executePrpPayout(pay)} className="bg-indigo-600 text-white px-4 py-2 rounded-xl font-black uppercase text-xs hover:bg-indigo-700 shadow-md">Payer</button>
                            </div>
                          ) : pay.status === 'rejected' ? (
                            <span className="text-red-500 font-bold text-xs bg-red-50 px-3 py-1 rounded-full"><FaTimes className="inline mr-1" /> Refusé</span>
                          ) : (
                            <span className="text-green-600 font-bold text-xs bg-green-50 px-3 py-1 rounded-full"><FaCheckCircle className="inline mr-1" /> Payé le {new Date(pay.paid_at).toLocaleDateString()}</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                  </div>
                </div>
              )}
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
              <div className="p-6 border-b border-slate-100 bg-purple-50">
                <h3 className="font-black text-purple-900 flex items-center gap-2"><FaBullhorn className="text-purple-600" /> Virements Affiliés</h3>
              </div>
              {payouts.length === 0 ? (
                <div className="p-5 md:p-10 text-center text-slate-400 font-bold">Aucune demande en attente.</div>
              ) : (
                <div className="overflow-x-auto">
                  <div className="min-w-[900px]">
                    <table className="w-full text-left">
                  <thead className="bg-slate-50 text-slate-500">
                    <tr><th className="p-6 text-xs font-black uppercase">Date</th><th className="p-6 text-xs font-black uppercase">Affilié</th><th className="p-6 text-xs font-black uppercase">Montant</th><th className="p-6 text-xs font-black uppercase">Méthode</th><th className="p-6 text-right text-xs font-black uppercase">Action</th></tr>
                  </thead>
                  <tbody>
                    {payouts.map(pay => (
                      <tr key={pay.id} className="border-b border-slate-50 hover:bg-slate-50">
                        <td className="p-6 text-xs font-bold text-slate-500">{new Date(pay.created_at).toLocaleDateString()}</td>
                        <td className="p-6 font-bold text-slate-900">{pay.affiliate?.referral_code}</td>
                        <td className="p-6 font-black text-green-600 text-lg">{pay.amount}$</td>
                        <td className="p-6 text-xs font-bold text-slate-600">{pay.payment_method}</td>
                        <td className="p-6 text-right">
                          {pay.status === 'pending' ? (
                            <button onClick={() => executePayout(pay)} className="bg-green-600 text-white px-4 py-2 rounded-xl font-black uppercase text-xs hover:bg-green-700 shadow-md">Payer via Stripe</button>
                          ) : (
                            <span className="text-green-600 font-bold text-xs bg-green-50 px-3 py-1 rounded-full"><FaCheckCircle className="inline mr-1" /> Payé</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* VIDEOS */}
        {activeTab === 'videos' && (
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-2xl border border-slate-200 h-fit shadow-sm">
              <h2 className="font-black mb-4 text-slate-800 flex items-center gap-2"><FaVideo className="text-pink-600" /> Ajouter une vidéo</h2>
              <div className="space-y-4">
                <input className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 font-bold text-sm" placeholder="Titre (ex: Visite du Vieux-Québec)" value={newVideoTitle} onChange={e => setNewVideoTitle(e.target.value)} />
                <div className="relative border-2 border-dashed border-slate-300 rounded-xl p-6 text-center hover:bg-slate-50 transition cursor-pointer group">
                  <input type="file" accept="video/mp4,video/quicktime" onChange={handleVideoUpload} disabled={uploadingVideo} className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" />
                  {uploadingVideo ? (
                    <div className="text-pink-600 font-black animate-pulse">Téléchargement en cours...</div>
                  ) : (
                    <div className="text-slate-500 group-hover:text-pink-600 transition">
                      <FaCloudUploadAlt className="mx-auto text-3xl mb-2" />
                      <p className="text-xs font-bold uppercase">Cliquez pour upload (MP4)</p>
                      <p className="text-[10px] mt-1">Format vertical (9:16) recommandé</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="lg:col-span-2">
              <h3 className="font-black text-slate-800 mb-4">Vidéos en ligne ({homeVideos.length})</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {homeVideos.map(video => (
                  <div key={video.id} className="bg-slate-900 rounded-2xl overflow-hidden relative group aspect-[9/16] border border-slate-200 shadow-md">
                    <video src={video.video_url} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition" muted loop onMouseOver={e => e.currentTarget.play()} onMouseOut={e => e.currentTarget.pause()} />
                    <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 to-transparent p-3"><p className="text-white font-bold text-xs truncate">{video.title}</p></div>
                    <button onClick={() => deleteVideo(video.id, video.video_url)} className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition hover:scale-110"><FaTrash size={12} /></button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* AFFILIATES (Gestion) */}
        {activeTab === 'affiliates' && (
          <div className="bg-white rounded-[2rem] shadow-sm border border-slate-100 overflow-hidden">
            <div className="overflow-x-auto">
              <div className="min-w-[900px]">
                <table className="w-full text-left">
              <thead className="bg-purple-50 border-b border-purple-100 text-purple-900">
                <tr><th className="p-6 text-xs font-black uppercase">Code</th><th className="p-6 text-xs font-black uppercase">Rémunération</th><th className="p-6 text-xs font-black uppercase">Performance</th><th className="p-6 text-xs font-black uppercase">Statut</th><th className="p-6 text-right text-xs font-black uppercase">Actions</th></tr>
              </thead>
              <tbody>
                {affiliates.length === 0 ? <tr><td colSpan={5} className="p-5 md:p-10 text-center text-slate-400 font-bold">Aucun affilié trouvé.</td></tr> : affiliates.map(aff => (
                  <tr key={aff.id} className="border-b border-slate-50 hover:bg-slate-50 transition">
                    <td className="p-6"><div className="font-black text-slate-800 text-lg">{aff.referral_code}</div><div className="text-xs text-slate-400">{new Date(aff.created_at).toLocaleDateString()}</div></td>
                    <td className="p-6">{aff.remuneration_mode === 'commission' ? <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-black">{aff.commission_percent}%</span> : <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-black">{aff.fixed_rate}$ / vente</span>}</td>
                    <td className="p-6"><div className="text-sm font-bold">{Number(aff.total_earnings || 0).toFixed(2)}$</div><div className="text-xs text-slate-400">{aff.clicks_count} clics</div></td>
                    <td className="p-6">{aff.status === 'active' ? <span className="text-green-600 font-bold text-xs flex items-center gap-1"><FaCheckCircle /> Actif</span> : <span className="text-amber-500 font-bold text-xs flex items-center gap-1"><FaClock /> Attente</span>}</td>
                    <td className="p-6 text-right">
                      <button onClick={() => setEditingAffiliate(aff)} className="bg-purple-50 text-purple-600 p-2 rounded-lg mr-2"><FaEdit /></button>
                      <button onClick={() => toggleAffiliateStatus(aff)} className={`p-2 rounded-lg mr-2 ${aff.status === 'active' ? 'bg-amber-50 text-amber-600' : 'bg-green-50 text-green-600'}`}>{aff.status === 'active' ? <FaTimes /> : <FaCheck />}</button>
                      <button onClick={() => deleteAffiliate(aff.id)} className="p-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100"><FaTrash /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
              </div>
            </div>
          </div>
        )}

        {/* ANNONCES */}
        {activeTab === 'announcements' && (
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-2xl border border-slate-200 h-fit shadow-sm">
              <h2 className="font-black mb-4 text-slate-800 flex items-center gap-2"><FaPaperPlane className="text-orange-600" /> Nouvelle annonce</h2>
              <form onSubmit={handlePostAnnouncement} className="space-y-4">
                <input className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 font-bold text-sm" placeholder="Titre" value={newAnnouncement.title} onChange={e => setNewAnnouncement({ ...newAnnouncement, title: e.target.value })} />
                <textarea className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 h-32 text-sm" placeholder="Message" value={newAnnouncement.content} onChange={e => setNewAnnouncement({ ...newAnnouncement, content: e.target.value })} />
                <button type="submit" className="w-full bg-orange-600 text-white py-3 rounded-xl font-black uppercase tracking-widest hover:bg-orange-700 transition shadow-lg">Publier</button>
              </form>
            </div>
            <div className="lg:col-span-2 space-y-4">
              {announcements.map(a => (
                <div key={a.id} className="bg-white p-5 rounded-2xl border border-slate-200 flex justify-between items-start shadow-sm hover:border-orange-200 transition">
                  <div><h3 className="font-bold text-slate-800 text-lg">{a.title}</h3><p className="text-sm text-slate-500 mt-1">{a.content}</p></div>
                  <button onClick={() => deleteAnnouncement(a.id)} className="p-2 bg-slate-50 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition"><FaTrash /></button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* NEWSLETTER */}
        {activeTab === 'newsletter' && (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="lg:col-span-5 space-y-6">
              <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                <h3 className="font-black text-slate-900 mb-4 flex items-center gap-2"><FaUserPlus className="text-green-600" /> Destinataires</h3>
                <div className="bg-green-50 p-4 rounded-xl border border-green-100 mb-4">
                  <p className="text-2xl font-black text-slate-900">{subscribers.length + manualRecipientsList.length}</p><p className="text-xs text-green-700 font-bold">Total (Abonnés + Manuels)</p>
                </div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Ajout manuel</label>
                <textarea className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 h-24 text-xs font-mono" placeholder="email1@test.com, email2@test.com..." value={manualRecipients} onChange={(e) => setManualRecipients(e.target.value)} />
              </div>
              <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                <h3 className="font-black text-slate-900 mb-4 flex items-center gap-2"><FaEnvelopeOpenText className="text-blue-600" /> Abonnés collectés (Footer)</h3>
                <div className="max-h-[320px] overflow-y-auto border border-slate-100 rounded-xl">
                  {subscribers.length === 0 ? <div className="p-6 text-center text-slate-400 font-bold text-sm">Aucun abonné.</div> : (
                    <div className="overflow-x-auto">
                      <div className="min-w-[640px]">
                        <table className="w-full text-left">
                      <thead className="bg-slate-50 border-b border-slate-100 sticky top-0">
                        <tr><th className="p-3 text-[10px] font-black uppercase text-slate-500">Courriel</th><th className="p-3 text-[10px] font-black uppercase text-slate-500">Code postal</th><th className="p-3 text-right text-[10px] font-black uppercase text-slate-500">Action</th></tr>
                      </thead>
                      <tbody>
                        {subscribers.map((s) => (
                          <tr key={s.id} className="border-b border-slate-50 hover:bg-slate-50">
                            <td className="p-3 text-xs font-bold text-slate-700 break-all">{s.email}</td><td className="p-3 text-xs text-slate-600 font-semibold">{s.postal_code || '—'}</td>
                            <td className="p-3 text-right"><button onClick={() => deleteSubscriber(s.id)} className="text-slate-400 hover:text-red-600 transition"><FaTrash /></button></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm h-[600px] flex flex-col">
                <h3 className="font-black text-slate-900 mb-4 flex items-center gap-2"><FaList className="text-blue-500" /> Contenu à inclure</h3>
                <div className="flex-1 overflow-y-auto space-y-4 pr-2 custom-scrollbar">
                  <div>
                    <p className="text-xs font-black text-red-500 uppercase tracking-widest mb-2 sticky top-0 bg-white py-1">🔥 Last Call</p>
                    {deals.map(item => (
                      <label key={`deal-${item.id}`} className="flex items-start gap-3 p-2 rounded-xl border cursor-pointer mb-2 transition hover:bg-slate-50">
                        <input type="checkbox" className="mt-1" checked={!!selectedItems.find(i => i.id === String(item.id) && i.type === 'deal')} onChange={() => toggleItemSelection(item, 'deal')} />
                        <div className="flex-1"><div className="font-bold text-xs">{item.title}</div><div className="text-[10px] text-slate-500">{item.discount_price}$</div></div>
                      </label>
                    ))}
                  </div>
                  <div>
                    <p className="text-xs font-black text-blue-500 uppercase tracking-widest mb-2 sticky top-0 bg-white py-1">🏨 Hébergements</p>
                    {accommodations.map(item => (
                      <label key={`acc-${item.id}`} className="flex items-start gap-3 p-2 rounded-xl border cursor-pointer mb-2 transition hover:bg-slate-50">
                        <input type="checkbox" className="mt-1" checked={!!selectedItems.find(i => i.id === String(item.id) && i.type === 'accommodation')} onChange={() => toggleItemSelection(item, 'accommodation')} />
                        <div className="flex-1"><div className="font-bold text-xs">{item.name}</div><div className="text-[10px] text-slate-500">{item.price_per_night}$/nuit</div></div>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:col-span-7 space-y-6">
              <div className="bg-gradient-to-r from-slate-800 to-slate-900 p-6 rounded-2xl text-white shadow-lg flex justify-between items-center">
                <div><h3 className="font-black text-lg flex items-center gap-2"><FaRobot /> Assistant Rédaction</h3><p className="text-slate-400 text-xs">Générez un email HTML pro.</p></div>
                <button onClick={generateNewsletterContent} disabled={isGenerating || selectedItems.length === 0} className="bg-white text-slate-900 px-6 py-3 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-green-400 transition disabled:opacity-50">{isGenerating ? "Création..." : "Générer ✨"}</button>
              </div>
              <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden h-[600px] flex flex-col">
                <div className="p-4 border-b border-slate-100 bg-slate-50 flex justify-between items-center">
                  <span className="text-xs font-black text-slate-500 uppercase">Aperçu</span>
                  <input className="px-3 py-1 text-sm border border-slate-300 rounded-lg w-1/2" placeholder="Sujet..." value={newsletterSubject} onChange={(e) => setNewsletterSubject(e.target.value)} />
                </div>
                <div className="flex-1 overflow-y-auto p-8 bg-slate-100">
                  {newsletterHtml ? <div className="bg-white shadow-xl mx-auto max-w-[600px] min-h-[500px] p-0" dangerouslySetInnerHTML={{ __html: newsletterHtml }} /> : <div className="h-full flex flex-col items-center justify-center text-slate-300"><FaMagic size={40} className="mb-4 opacity-20" /><p className="text-sm">En attente de génération...</p></div>}
                </div>
                <div className="p-4 border-t border-slate-200 bg-white flex justify-end">
                  <button onClick={sendCampaign} disabled={isSending || !newsletterHtml} className="bg-green-600 text-white px-8 py-3 rounded-xl font-black uppercase tracking-widest hover:bg-green-700 transition shadow-lg disabled:opacity-50 flex items-center gap-2">{isSending ? 'Envoi...' : <><FaPaperPlane /> Envoyer</>}</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 🚀 OUTIL SDR IA AUTONOME & GESTION MANUELLE */}
        {activeTab === 'sdr' && (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 animate-in fade-in slide-in-from-bottom-4">

            {/* COLONNE GAUCHE : Configuration IA & Ajout Manuel */}
            <div className="lg:col-span-4 space-y-6">

              {/* Module Gemini */}
              <div className="bg-slate-900 p-6 rounded-2xl border border-slate-700 shadow-xl text-white">
                <h3 className="font-black text-xl mb-4 flex items-center gap-2">
                  <FaRobot className="text-blue-400" /> Cerveau SDR (Gemini)
                </h3>
                <p className="text-xs text-slate-400 mb-6">Configurez les paramètres de scraping et de personnalisation pour l'envoi à froid.</p>

                <div className="space-y-4">
                  <div>
                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Cible (Secteur/URL)</label>
                    <input
                      type="text"
                      value={sdrTarget}
                      onChange={(e) => setSdrTarget(e.target.value)}
                      placeholder="Ex: Hôtels à Québec, linkedin.com/company/..."
                      className="w-full p-3 bg-slate-800 rounded-xl border border-slate-600 outline-none text-sm font-medium focus:border-blue-500 transition"
                    />
                  </div>
                  <div>
                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Angle d'approche (Prompt)</label>
                    <textarea
                      value={sdrPrompt}
                      onChange={(e) => setSdrPrompt(e.target.value)}
                      className="w-full p-3 bg-slate-800 rounded-xl border border-slate-600 h-24 text-xs outline-none focus:border-blue-500 transition"
                      placeholder="Analyse leur site web et rédige un courriel de 3 lignes max proposant le Last Call de Forfeo. Ton direct et québécois."
                    />
                  </div>
                  <div className="flex items-center justify-between p-3 bg-slate-800/50 rounded-xl border border-slate-700">
                    <span className="text-xs font-bold">Générer Démo Dynamique</span>
                    <input
                      type="checkbox"
                      checked={sdrGenerateDemo}
                      onChange={(e) => setSdrGenerateDemo(e.target.checked)}
                      className="w-4 h-4 accent-blue-500"
                    />
                  </div>

                  <button
                    onClick={handleSdrScraping}
                    disabled={sdrLoading}
                    className="w-full bg-blue-600 text-white py-3 rounded-xl font-black uppercase tracking-widest hover:bg-blue-500 transition shadow-[0_0_15px_rgba(59,130,246,0.5)] flex items-center justify-center gap-2 disabled:opacity-50"
                  >
                    {sdrLoading ? <FaSpinner className="animate-spin" /> : <FaSearch />}
                    {sdrLoading ? 'Génération...' : 'Lancer le Scraping'}
                  </button>
                </div>
              </div>

              {/* Module Ajout Manuel */}
              <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                <h4 className="font-black text-slate-800 mb-4 flex items-center gap-2">
                  <FaPlus className="text-blue-500"/> Ajout Manuel de Lead
                </h4>
                <form onSubmit={handleManualSdrAdd} className="space-y-3">
                  <input
                    type="text"
                    placeholder="Nom de l'entreprise"
                    required
                    value={newSdrCompany}
                    onChange={(e) => setNewSdrCompany(e.target.value)}
                    className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 text-sm font-bold focus:border-blue-500 outline-none"
                  />
                  <input
                    type="email"
                    placeholder="Email (Optionnel)"
                    value={newSdrEmail}
                    onChange={(e) => setNewSdrEmail(e.target.value)}
                    className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 text-sm font-bold focus:border-blue-500 outline-none"
                  />
                  <button
                    type="submit"
                    className="w-full bg-slate-900 text-white py-3 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-slate-800 transition shadow-md flex items-center justify-center gap-2"
                  >
                    Créer la Démo
                  </button>
                </form>
              </div>

              {/* Stats rapides */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm">
                  <p className="text-[10px] font-black text-slate-400 uppercase">Total Leads</p>
                  <p className="text-2xl font-black text-slate-800 mt-1">{sdrLeads.length}</p>
                </div>
                <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm">
                  <p className="text-[10px] font-black text-slate-400 uppercase">Démos Générées</p>
                  <p className="text-2xl font-black text-blue-600 mt-1">{sdrLeads.filter(l => l.demo_slug).length}</p>
                </div>
              </div>
            </div>

            {/* COLONNE DROITE : Séquences (Resend) et Pipeline */}
            <div className="lg:col-span-8 space-y-6">
              <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden flex flex-col h-[750px]">
                <div className="p-6 border-b border-slate-100 bg-slate-50 flex justify-between items-center">
                  <div>
                    <h3 className="font-black text-slate-900 flex items-center gap-2">
                      <FaPaperPlane className="text-indigo-600" /> Pipeline Resend & Démos
                    </h3>
                    <p className="text-xs text-slate-500 mt-1 font-bold">Aperçu des courriels et gestion des leads.</p>
                  </div>
                  <button
                    onClick={handleSendAllSdrEmails}
                    className="bg-slate-900 text-white px-4 py-2 rounded-xl text-xs font-black uppercase tracking-widest hover:bg-slate-800 transition flex items-center gap-2 shadow-md"
                  >
                    <FaMagic /> Approuver & Envoyer Tout
                  </button>
                </div>

                <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-slate-50/50">

                  {sdrLeads.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-full text-slate-400">
                      <FaRobot size={40} className="mb-4 opacity-20" />
                      <p className="font-bold text-sm">Aucun courriel généré pour le moment.</p>
                      <p className="text-xs mt-1">Utilisez le panneau de gauche pour ajouter ou générer un lead.</p>
                    </div>
                  ) : (
                    sdrLeads.map((lead) => (
                      <div key={lead.id} className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm hover:border-indigo-300 transition group cursor-pointer">
                        <div className="flex justify-between items-start mb-3">
                          <div>
                            <h4 className="font-bold text-slate-800 capitalize">{lead.company_name}</h4>
                            <p className="text-xs text-slate-400">{lead.email || "Aucun email défini"} • {lead.website_url}</p>
                          </div>

                          {/* BADGES STATUT */}
                          <span className={`px-2 py-1 rounded text-[10px] font-black uppercase ${
                            lead.status === 'sent' ? 'bg-indigo-100 text-indigo-700' :
                            lead.status === 'viewed' ? 'bg-green-100 text-green-700' :
                            'bg-amber-100 text-amber-700'
                          }`}>
                            {lead.status === 'drafted' ? "Prêt à l'envoi" :
                             lead.status === 'sent' ? "Envoyé ✈️" :
                             lead.status === 'viewed' ? "Démo Ouverte 👀" :
                             lead.status}
                          </span>
                        </div>

                        <div className="bg-slate-50 p-3 rounded-lg border border-slate-100 text-xs text-slate-600 font-medium mb-3 relative whitespace-pre-wrap">
                          <span className="absolute -top-2 left-3 bg-slate-900 text-white text-[11px] font-black px-2 py-0.5 rounded uppercase">Brouillon</span>
                          {lead.email_draft || "Aucun brouillon généré pour ce lead."}
                        </div>

                        <div className="flex justify-between items-center">
                          {lead.demo_slug && (
                            <span className="text-[10px] text-blue-600 font-bold bg-blue-50 px-2 py-1 rounded flex items-center gap-1">
                              <FaVideo /> forfeoexplore.com/demo/{lead.demo_slug}
                            </span>
                          )}

                          {/* ACTIONS : VISUALISER, MODIFIER, ENVOYER, SUPPRIMER */}
                          <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition ml-auto">

                            {lead.demo_slug && (
                              <button
                                onClick={() => window.open(`/demo/${lead.demo_slug}`, '_blank')}
                                className="p-1.5 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md transition"
                                title="Voir la démo"
                              >
                                <FaExternalLinkAlt size={12} />
                              </button>
                            )}

                            <button
                              onClick={() => handleEditSdrLead(lead)}
                              className="p-1.5 text-slate-500 bg-slate-100 hover:bg-slate-200 rounded-md transition"
                              title="Modifier l'email cible"
                            >
                              <FaEdit size={12} />
                            </button>

                            {lead.status !== 'sent' && lead.status !== 'viewed' && (
                              <button
                                onClick={() => handleSendSdrEmail(lead)}
                                className="p-1.5 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md transition"
                                title="Envoyer le courriel via Resend"
                              >
                                <FaPaperPlane size={12} />
                              </button>
                            )}

                            <button
                              onClick={() => handleDeleteSdrLead(lead.id)}
                              className="p-1.5 text-red-500 bg-red-50 hover:bg-red-100 rounded-md transition"
                              title="Supprimer définitivement"
                            >
                              <FaTrash size={12} />
                            </button>

                          </div>
                        </div>
                      </div>
                    ))
                  )}

                </div>
              </div>
            </div>
          </div>
        )}

        {/* TUTORIELS & FAQ PROS */}
        {activeTab === 'tutorials' && (
          <div className="grid lg:grid-cols-3 gap-8 animate-in fade-in">
            <div className="bg-white p-6 rounded-2xl border border-slate-200 h-fit shadow-sm">
              <h2 className="font-black mb-4 text-slate-800 flex items-center gap-2">
                <FaBookOpen className="text-teal-600" /> Ajouter Tuto / FAQ
              </h2>
              <form onSubmit={handleAddTutorial} className="space-y-4">
                <div>
                  <label className="block text-xs font-black text-slate-400 uppercase mb-1">Catégorie du Menu</label>
                  <select value={newTutorial.category} onChange={e => setNewTutorial({...newTutorial, category: e.target.value})} className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 font-bold text-sm">
                    {TUTORIAL_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-black text-slate-400 uppercase mb-1">Question / Titre</label>
                  <input className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 font-bold text-sm" placeholder="Ex: Comment scanner un code QR ?" required value={newTutorial.title} onChange={e => setNewTutorial({ ...newTutorial, title: e.target.value })} />
                </div>
                <div>
                  <label className="block text-xs font-black text-slate-400 uppercase mb-1">Réponse / Explication</label>
                  <textarea className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 h-32 text-sm resize-none" placeholder="Explications détaillées..." required value={newTutorial.content} onChange={e => setNewTutorial({ ...newTutorial, content: e.target.value })} />
                </div>
                <div>
                  <label className="block text-xs font-black text-slate-400 uppercase mb-1">Lien Vidéo (Optionnel)</label>
                  <input className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 font-bold text-sm" placeholder="Ex: [https://youtube.com/watch?v=]..." value={newTutorial.video_url} onChange={e => setNewTutorial({ ...newTutorial, video_url: e.target.value })} />
                </div>
                <button type="submit" className="w-full bg-teal-600 text-white py-4 rounded-xl font-black uppercase tracking-widest hover:bg-teal-700 transition shadow-lg mt-2">Publier</button>
              </form>
            </div>

            <div className="lg:col-span-2 space-y-4">
              <h3 className="font-black text-xl mb-4 flex items-center gap-2"><FaQuestionCircle className="text-slate-400"/> Tutos et FAQ en ligne</h3>
              {tutorials.length === 0 ? (
                <div className="text-center py-10 border-2 border-dashed border-slate-200 rounded-2xl">
                  <p className="text-slate-400 font-bold">Aucun tutoriel/FAQ enregistré.</p>
                </div>
              ) : (
                tutorials.map(t => (
                  <div key={t.id} className="bg-white p-6 rounded-2xl border border-slate-200 flex justify-between items-start shadow-sm hover:border-teal-200 transition">
                    <div className="flex-1 pr-4">
                      <span className="text-[10px] font-black uppercase tracking-widest text-teal-600 bg-teal-50 px-2 py-1 rounded-md mb-2 inline-block">{t.category}</span>
                      <h3 className="font-bold text-slate-800 text-lg leading-tight">{t.title}</h3>
                      <p className="text-sm text-slate-500 mt-2 whitespace-pre-wrap leading-relaxed">{t.content}</p>
                      {t.video_url && (
                        <a href={t.video_url} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-xs text-blue-500 hover:text-blue-700 font-bold mt-3 transition w-fit bg-blue-50 px-3 py-1.5 rounded-lg">
                          <FaVideo /> Voir le tutoriel vidéo
                        </a>
                      )}
                    </div>
                    <button onClick={() => deleteTutorial(t.id)} className="p-3 bg-slate-50 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-xl transition" title="Supprimer">
                      <FaTrash />
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* SÉCURITÉ */}
        {activeTab === 'security' && (
          <div className="max-w-2xl mx-auto bg-white p-8 rounded-2xl border border-slate-200 shadow-lg">
            <h2 className="text-2xl font-black mb-6 flex items-center gap-2"><FaLock className="text-red-600" /> Sécurité</h2>
            {passwordMessage && <div className={`p-4 rounded-xl mb-6 text-sm font-bold ${passwordMessage.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>{passwordMessage.text}</div>}
            <form onSubmit={handleUpdatePassword} className="space-y-4">
              <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="w-full p-4 bg-slate-50 rounded-xl border border-slate-200 font-bold" placeholder="Nouveau mot de passe" required />
              <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="w-full p-4 bg-slate-50 rounded-xl border border-slate-200 font-bold" placeholder="Confirmer" required />
              <button type="submit" className="w-full bg-slate-900 text-white py-4 rounded-xl font-black uppercase tracking-widest hover:bg-slate-800 transition">Mettre à jour</button>
            </form>
          </div>
        )}
      </div>

      <style dangerouslySetInnerHTML={{ __html: `.hide-scrollbar::-webkit-scrollbar { display: none; }` }} />

      {/* LOT0E2_REGION_FIRST_PRP_ASSIGNMENT_PANEL_MOUNT */}
      {activeTab === 'prps' && (
        <PrpAdminTerritoryRegionAssignmentPanel />
      )}

      {activeTab === 'prps' && (
        <PrpAdminTerritoryCoordinateValidationPanel />
      )}
</div>
  );
}
